import { createSlice } from "@reduxjs/toolkit";

const defaultMealsPerDay = {
  breakfast: [0],  // Now stores arrays by default
  lunch: [0],
  dinner: [0],
};

const initialMealToShow = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
].reduce((acc, day) => {
  acc[day] = { ...defaultMealsPerDay };
  return acc;
}, {});

const initialState = {
  mealToShow: initialMealToShow,
  mealOptions: {},
};

const selectedMealsSlice = createSlice({
  name: "selectedMeals",
  initialState,
  reducers: {
    setMealsToShow: (state, { payload: { day, mealType, indexes } }) => {
      if (!state.mealToShow[day]) {
        state.mealToShow[day] = { ...defaultMealsPerDay };
      }
      // Ensure we always have an array of numbers
      state.mealToShow[day][mealType] = Array.isArray(indexes) 
        ? indexes.map(Number).filter(i => !isNaN(i))
        : [Number(indexes)].filter(i => !isNaN(i));
    },

    addMealIndex: (state, { payload: { day, mealType, index } }) => {
      if (!state.mealToShow[day]) {
        state.mealToShow[day] = { ...defaultMealsPerDay };
      }
      
      const currentIndexes = state.mealToShow[day][mealType] || [];
      const numericIndex = Number(index);
      
      if (!isNaN(numericIndex) && !currentIndexes.includes(numericIndex)) {
        state.mealToShow[day][mealType] = [...currentIndexes, numericIndex];
      }
    },

    removeMealIndex: (state, { payload: { day, mealType, index } }) => {
      if (state.mealToShow[day]?.[mealType]) {
        state.mealToShow[day][mealType] = state.mealToShow[day][mealType]
          .filter(i => i !== Number(index));
      }
    },

    resetAllMealsToShow: (state) => {
      state.mealToShow = Object.keys(initialMealToShow).reduce((acc, day) => {
        acc[day] = { ...defaultMealsPerDay };
        return acc;
      }, {});
    },

    addMealOption: (state, { payload: { day, mealType, mealId } }) => {
      if (!state.mealOptions[day]) {
        state.mealOptions[day] = {};
      }
      if (!state.mealOptions[day][mealType]) {
        state.mealOptions[day][mealType] = [];
      }
      const existingMeals = state.mealOptions[day][mealType];
      if (!existingMeals.includes(mealId)) {
        existingMeals.push(mealId);
      }
    },
  },
});

export const {
  setMealsToShow,
  addMealIndex,
  removeMealIndex,
  resetAllMealsToShow,
  addMealOption,
} = selectedMealsSlice.actions;

export default selectedMealsSlice;